import classNames from 'classnames/bind'
import PropTypes from 'prop-types'

import styles from './Radio.module.scss'

const cx = classNames.bind(styles)

const Radio = ({
  checked,
  children,
  classes,
  id,
  name,
  onChange,
  value,
  dataTestId,
}) => (
  <div
    className={`${styles.radio} ${checked ? styles.selected : ''} ${cx(
      classes
    )}`}
  >
    <fieldset
      className={styles.fieldset}
      onClick={onChange}
      role='presentation'
    >
      <span className={styles.inputContainer}>
        <input
          checked={checked}
          className={styles.inputCustom}
          data-testid={dataTestId}
          id={id}
          name={name}
          onChange={onChange}
          type='radio'
          value={value}
        />
        <label
          className={`${styles.inputCustomLabel} ${styles.customRadio} ${styles.inputText}`}
          htmlFor={id}
        >
          {children}
        </label>
      </span>
    </fieldset>
  </div>
)

Radio.defaultProps = {
  checked: false,
  classes: {},
  dataTestId: '',
}

Radio.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.string.isRequired,
  classes: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  dataTestId: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
}

export default Radio
